import { styled } from '@vebox/etui-system';
import { useState, useEffect, createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { P, Div, Label } from '@vebox/etui-system-elements';

const _excluded = ["theme"];
const ColorLabel = styled(P).attrs(_ref => {
  let {
      theme
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2(_objectSpread2({}, rest), {}, {
    m: 0,
    mb: `${theme.spacing.xxs}px`,
    fontSize: theme.typography.fontSizeBase,
    color: theme.palette.text.secondary
  });
})`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: fit-content;
`;

const _excluded$1 = ["theme"];
const ColorDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  return _objectSpread2(_objectSpread2({}, rest), {}, {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius
  });
})`
  flex: 1;
  width: 100%;
`;

const _excluded$2 = ["theme"];
const ColorPickerWrapper = styled(Div).attrs(_ref => {
  let rest = _objectWithoutProperties(_ref, _excluded$2);
  return _objectSpread2(_objectSpread2({}, rest), {}, {
    height: '52px',
    width: '52px'
  });
})`
  display: flex;
  flex-direction: column;
  transition: 0.2s;

  &:hover {
    filter: brightness(0.95);
  }
`;

const ColorPicker = ({
  name,
  defaultValue,
  onChange,
  label,
  styles = {}
}) => {
  const [color, setColor] = useState(defaultValue);
  useEffect(() => {
    setColor(defaultValue);
  }, [defaultValue]);
  return /*#__PURE__*/createElement(Label, _extends({
    style: {
      cursor: 'pointer'
    },
    htmlFor: `colorPicker-${name}`,
    maxWidth: "fit-content"
  }, styles.root), /*#__PURE__*/createElement(ColorPickerWrapper, {
    style: styles.wrapper
  }, label && /*#__PURE__*/createElement(ColorLabel, {
    style: styles.label
  }, label), /*#__PURE__*/createElement(ColorDiv, {
    bg: color || defaultValue,
    style: styles.input
  }), /*#__PURE__*/createElement("input", {
    id: `colorPicker-${name}`,
    name: `colorPicker-${name}`,
    type: "color",
    defaultValue: defaultValue,
    style: _objectSpread2({
      opacity: 0,
      position: 'absolute',
      width: '1px',
      height: '1px',
      flex: 1,
      zIndex: '0'
    }, styles.htmlInput),
    onBlur: e => {
      setColor(e.target.value);
      onChange(e.target.value);
    }
  })));
};

export default ColorPicker;
